import ApiService from "@/api/ApiService";
import NewRangePicker from "@/shared/forms/NewRangePicker";
import { Box, Button, CircularProgress, FormControl, MenuItem, Select, Stack, TextField, Typography } from "@mui/material";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosResponse } from "axios";
import dayjs from "dayjs";
import { useState } from "react";

export const vacationTypes = [
  { id: "vacation", name: "Urlaub" },
  { id: "doctor", name: "Arzttermin" },
];

const initialState = (staffMember: number) => ({
  staffMember,
  start: dayjs().add(1, "day").format("YYYY-MM-DD"),
  end: dayjs().add(1, "day").format("YYYY-MM-DD"),
  comment: "",
  type: "vacation",
});

export default function HolidayRequest({ resourceId, close, name }: { name: string; resourceId: number; close: () => void }) {
  const [state, setState] = useState(initialState(resourceId));
  const [showError, setShowError] = useState(false);
  const queryClient = useQueryClient();

  const mutation = useMutation<any, AxiosResponse, any>({
    mutationFn: ApiService.createEntity("vacationRequest", { v: "calendar" }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["getVacationRequests"] });
      queryClient.invalidateQueries({ queryKey: ["getCrewHolidayCalendar"] });
      close();
    },
  });

  const valid = true;

  return (
    <Stack spacing={"5px"}>
      <Typography>{name}</Typography>
      <Typography variant="h6">Abwesenheitsantrag</Typography>

      <Typography sx={{ userSelect: "none" }}>Art</Typography>

      <FormControl sx={{ minWidth: 170, mt: 0.5, mb: 1.5 }}>
        <Select
          displayEmpty
          value={state.type}
          onChange={(event) =>
            setState((s) => ({
              ...s,
              type: event.target.value,
            }))
          }
          sx={{
            height: 50,
            borderRadius: 1,
          }}
        >
          {vacationTypes.map((c) => (
            <MenuItem key={c.id} value={c.id}>
              {c.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <Typography sx={{ userSelect: "none" }}>Zeitraum</Typography>
      <NewRangePicker
        small
        onChange={([start, end]) => {
          setState((s) => ({
            ...s,
            start: !!start ? start.format("YYYY-MM-DD") : null,
            end: !!end ? end.format("YYYY-MM-DD") : null,
          }));
        }}
        value={[!!state.start ? dayjs(state.start) : null, !!state.end ? dayjs(state.end) : null]}
      />

      <Typography sx={{ userSelect: "none" }}>Kommentar</Typography>

      <TextField
        placeholder="Kommentar"
        multiline
        minRows={3}
        value={state.comment || ""}
        onChange={(event) => {
          const comment = event.target.value;
          setState((s) => ({
            ...s,
            comment,
          }));
        }}
        sx={{ mb: 2 }}
      />

      {showError && !valid && <Alert severity="error">Bitte überprüfe die Eingaben.</Alert>}

      {mutation.isPending ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            py: 2,
          }}
        >
          <CircularProgress size={24} />
        </Box>
      ) : (
        <Button
          sx={{ mt: 3, opacity: !valid ? 0.7 : 1 }}
          variant="contained"
          disabled={!valid}
          onClick={valid ? () => mutation.mutate(state) : () => setShowError(true)}
        >
          Speichern
        </Button>
      )}
    </Stack>
  );
}
